import { render, staticRenderFns } from "./H5Password.vue?vue&type=template&id=131f0bd3&scoped=true"
import script from "./H5Password.vue?vue&type=script&lang=js"
export * from "./H5Password.vue?vue&type=script&lang=js"
import style0 from "./H5Password.vue?vue&type=style&index=0&id=131f0bd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131f0bd3",
  null
  
)

export default component.exports